window.FsgbFortuneContent = {
  "numbers": {
    "1": {
      "english": "GENESIS",
      "landscape": "Ryukyu Vermilion",
      "theme": "Beginnings · Will · Leadership",
      "short": {
        "talent": "The ability to decide for yourself and take the first step.",
        "essence": "You value choosing for yourself and beginning in your own way.",
        "fortune": "Take the initiative, even with a small step."
      },
      "detail": {
        "talent": "You have the ability to think and decide for yourself, taking the first step toward something that does not yet exist. This number suggests a natural ability to offer direction when others are unsure.",
        "essence": "You value making your own choices and beginning in a way that feels true to you. Your strengths tend to emerge when you act from your own conviction rather than following someone else’s decisions.",
        "fortune": "Your theme is to begin on your own initiative, however small the step, without waiting for permission or perfect preparation.",
        "cycle": "A year to nurture new beginnings. It is a time to turn intuition into action and take the first step."
      }
    },
    "2": {
      "english": "HARMONY",
      "landscape": "Eternal Sunset",
      "theme": "Harmony · Trust · Connection",
      "short": {
        "talent": "The ability to understand feelings and bring people together.",
        "essence": "You value trust, kindness and thoughtful connections.",
        "fortune": "Ask for advice and accept help instead of carrying everything alone."
      },
      "detail": {
        "talent": "You have the ability to understand how others feel, connect people and build peaceful relationships. This number suggests a natural talent for creating an atmosphere where people can cooperate.",
        "essence": "You value trust, kindness and cooperation more than competition. Taking time to connect sincerely with someone can help you feel balanced.",
        "fortune": "Your theme is to ask for advice, accept help and listen patiently, instead of carrying everything on your own.",
        "cycle": "A year to nurture harmony and trust. Carefully developing relationships, rather than rushing to conclusions, can open the way forward."
      }
    },
    "3": {
      "english": "JOY",
      "landscape": "Fruits of Joy",
      "theme": "Joy · Expression · Creativity",
      "short": {
        "talent": "The ability to express feelings and brighten the atmosphere.",
        "essence": "You value enjoyment, curiosity and your own way of expressing yourself.",
        "fortune": "Speak, write or create. Give your feelings a form."
      },
      "detail": {
        "talent": "You have the ability to turn feelings into words, smiles, ideas and expression. This number suggests a talent for brightening the atmosphere and helping others feel lighter.",
        "essence": "You value enjoyment, curiosity and freedom of expression. You need time for things that move you, and for speaking or creating in your own way.",
        "fortune": "Your theme is to express what you feel through speaking, writing, laughing or creating, without waiting for perfection.",
        "cycle": "A year to nurture joy and expression. It is a time to give words or form to what you love, enjoy and want to share."
      }
    },
    "4": {
      "english": "HOME",
      "landscape": "Land of the Gods",
      "theme": "Stability · Trust · Foundations",
      "short": {
        "talent": "The ability to bring things into order and build something dependable.",
        "essence": "You value stability, sincerity and a tangible sense of progress.",
        "fortune": "Build a foundation for daily life through small habits."
      },
      "detail": {
        "talent": "You have the ability to organize things carefully, keep going steadily and build something dependable. This number suggests a talent for creating a foundation others can rely on.",
        "essence": "You value stability, sincerity and a tangible sense of progress. A sustainable foundation in life and work helps you feel calm and true to yourself.",
        "fortune": "Your theme is to strengthen the foundations of daily life, work and physical well-being, one step at a time. Small, consistent habits can help you move forward.",
        "cycle": "A year for building foundations. Rather than rushing toward results, it is a time to steadily organize your life, work, health and routines."
      }
    },
    "5": {
      "english": "FREEDOM",
      "landscape": "The Sea of Life",
      "theme": "Freedom · Change · Adventure",
      "short": {
        "talent": "The ability to adapt to change and discover new possibilities.",
        "essence": "You value the freedom to choose your path and experience something new.",
        "fortune": "Step beyond the familiar. Try a new path or experience."
      },
      "detail": {
        "talent": "You have the ability to adapt flexibly to change and discover new possibilities. This number suggests a talent for turning encounters with new places and people into meaningful experience.",
        "essence": "You value freedom, options, change and experience. You feel more at ease when you can choose your own path than when you remain in the same situation.",
        "fortune": "Your theme is to step a little beyond familiar methods and places, trying new paths, meeting people and exploring experiences.",
        "cycle": "A year to nurture change and action. It is a time to leave room in your plans for movement, encounters and new experiences."
      }
    },
    "6": {
      "english": "LOVE",
      "landscape": "Paradise of Flowers",
      "theme": "Love · Kindness · Beauty",
      "short": {
        "talent": "The ability to care for people and places and create a sense of ease.",
        "essence": "You value warm relationships and a life enriched by beauty.",
        "fortune": "Care for yourself too. Accept support, receive and rest."
      },
      "detail": {
        "talent": "You have the ability to care for people and places, notice what is needed and create a sense of ease. This number suggests a natural capacity to support others responsibly.",
        "essence": "You value warm relationships, beauty and harmony in daily life. You feel fulfilled when you can treat both yourself and those you love with care.",
        "fortune": "Your theme is to offer yourself the same love you give to others. Let asking for support, receiving and resting be part of your choices.",
        "cycle": "A year to nurture love and responsibility in close relationships and daily life. It is a time to care thoughtfully for family, home and beauty."
      }
    },
    "7": {
      "english": "WISDOM",
      "landscape": "Sky and Sea with the Wind",
      "theme": "Learning · Reflection · Essence",
      "short": {
        "talent": "The ability to think deeply and discover what matters beneath the surface.",
        "essence": "You value quiet time, learning and answers that make sense to you.",
        "fortune": "Make time to pause, explore and feel."
      },
      "detail": {
        "talent": "You have the ability to think deeply and look beyond the surface to what truly matters. This number suggests a talent for focusing independently and turning knowledge and experience into your own answers.",
        "essence": "You value quiet time, learning and answers that make sense to you. You need time away from surrounding voices to reconnect with what is within.",
        "fortune": "Your theme is to make time to pause, explore and feel, rather than rushing to an answer. Bring your attention back to the sensations in your body too.",
        "cycle": "A year to nurture learning and reflection. It is a time to deepen rather than expand, and clarify the answers within yourself."
      }
    },
    "8": {
      "english": "PROSPERITY",
      "landscape": "A Sky Full of Stars",
      "theme": "Abundance · Achievement · Circulation",
      "short": {
        "talent": "The ability to connect people and opportunities and turn them into results.",
        "essence": "You value the fruits of your efforts and using your strengths well.",
        "fortune": "Clarify your goals and what you receive in return, and practice receiving."
      },
      "detail": {
        "talent": "You have the ability to see resources such as people, time, money and opportunities as a whole, and bring them together into valuable results. This number suggests a talent for setting goals and mobilizing others.",
        "essence": "You value seeing effort become meaningful results and using your strengths responsibly. You feel fulfilled when you recognize your potential and contribute it to society.",
        "fortune": "Your theme is to receive without holding back, clarify your goals and what you receive in return, and keep taking worthwhile action.",
        "cycle": "A year to nurture achievement and the circulation of abundance. It is a time to organize goals, responsibilities, income and expenses, and give your efforts a visible form."
      }
    },
    "9": {
      "english": "ENLIGHTENMENT",
      "landscape": "The Shimmering Shore",
      "theme": "Acceptance · Compassion · Completion",
      "short": {
        "talent": "The ability to embrace different perspectives and share wisdom and kindness.",
        "essence": "You value compassion, peace and contributing to others.",
        "fortune": "Bring a chapter to a close, let go and make space for what comes next."
      },
      "detail": {
        "talent": "You have the ability to embrace people and events from a broad perspective and find meaning in experience. This number suggests a capacity to share wisdom and kindness for the benefit of others.",
        "essence": "You value compassion, peace and contributing to people and society. You are drawn to choices that improve things for everyone, beyond yourself alone.",
        "fortune": "Your theme is to bring what has ended to a close and release what is not yours to carry. Rather than holding everything, create room for what comes next.",
        "cycle": "A year to nurture completion and acceptance. It is a time to close chapters with gratitude, clear away what is no longer needed and prepare for a new beginning."
      }
    }
  }
};
